export const jpSentMail = {
  SC51heading1: "「support{'@'}yelloop.jp」よりメールをお送りしました。",
  SC51heading2: 'メールに記載されているURLより、パスワードを再設定してください。',
}
